// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"5152add8","108":"f4bfa394","260":"95ba5aa5","660":"96e4a87e","833":"b7f3d6cb"}[chunkId] + ".chunk.js";
};